import styled from 'common/styled-components';
import { Checkbox, MenuItem } from '@material-ui/core';

export const NameSpan = styled.span`
    flex: 3;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const CollaborateCheckbox = styled(Checkbox)`
    flex: 1;
`;
export const TKMenuItem = styled(MenuItem)`
    height: 48px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
`;
export const SearchHeaderItem = styled(MenuItem)`
    && {
        position: sticky;
        top: 0;
        z-index: 2;
        min-height: 50px;
        background-color: ${props => props.theme.secondary.contrastText};
        border-top: 1px solid ${props => props.theme.white.main};
        padding: 4px 8px;
    }
    &&:hover {
        background-color: ${props => props.theme.secondary.contrastText} !important;
    }
`;
export const ActionButton = styled.div`
    position: sticky;
    bottom: 0;
    z-index: 2;
    padding: 8px;
    text-align: right;
    background-color: ${props => props.theme.secondary.contrastText};
    border-top: 1px solid ${props => props.theme.white.main};
`;